import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 0.5rem;
`;
